
// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// const BreadcrumbFilterHeader = ({ locationName,totalProperties = 0,onFilter }) => {

//  const [keyword, setKeyword] = useState("");

//  const handleSearch = (e) => {
//   e.preventDefault();

//   if (!keyword.trim()) return;

//   console.log("Searching for:", keyword);

//   const updatedFilters = {
//     keyword: keyword.trim(),
//   };

//   onFilter?.(updatedFilters); // 🔥 parent will handle API call
// };


//  return (
//     <div className="filterouter align-items-center">
//       <div className="breadcrumbinner">
//         <div className="w-100">
//           <ol className="breadcrumb">
//             <li>
//               <Link to="/">Home</Link>
//             </li>
//             <li className="active">Homestays in {locationName} </li>
//           </ol>
//           {totalProperties > 0 ? (
//           <p>{totalProperties} properties available</p>
//         ) : (
//           <p className="no-results">
//             No homestays found in <strong>{locationName}</strong>.  

//           </p>
//         )}
//         </div>
//         <a href="#" className="theme-btn filterbtn">
//           <svg
//             viewBox="0 0 24 24"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               fillRule="evenodd"
//               clipRule="evenodd"
//               d="M3 7C3 6.44772 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H4C3.44772 8 3 7.55228 3 7ZM6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12ZM9 17C9 16.4477 9.44772 16 10 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H10C9.44772 18 9 17.5523 9 17Z"
//               fill="currentColor"
//             />
//           </svg>
//         </a>
//       </div>

//       {/* Whole search is a form */}
//       <form className="filterbx" onSubmit={handleSearch}>
//         <div className="formgroup">
//           <input
//             type="text"
//             className="form-control"
//             placeholder="Enter Home Stay name"
//             value={keyword}
//             onChange={(e) => setKeyword(e.target.value)}

//           />
//           <button type="submit" className="searchbtn">
//             <i className="icon icon-search"></i>
//           </button>
//         </div>

//         <div className="formgroup">
//           <select className="form-select">
//             <option value="" hidden>
//               Sort By:
//             </option>
//             <option>Price: Low to High</option>
//             <option>Price: High to Low</option>
//             <option>Newest</option>
//             <option>Oldest</option>
//           </select>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default BreadcrumbFilterHeader;


import React, { useState } from "react";
import { Link } from "react-router-dom";

const BreadcrumbFilterHeader = ({ locationName, totalProperties = 0, onFilter, onToggleSidebar }) => {
  const [keyword, setKeyword] = useState("");
  const [sortBy, setSortBy] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    onFilter?.({ keyword: keyword.trim(), sort_by: sortBy });
  };

  const handleSortChange = (e) => {
    const value = e.target.value;
    setSortBy(value);

    let sortParams = {
      keyword: keyword.trim(), //. keep keyword
    };

    if (value === "price_low_high") {
      sortParams.sort_by = "price_min";
      sortParams.sort_order = "asc";
    } else if (value === "price_high_low") {
      sortParams.sort_by = "price_min";
      sortParams.sort_order = "desc";
    } else if (value === "newest") {
      sortParams.sort_by = "createdAt";
      sortParams.sort_order = "desc";
    } else if (value === "oldest") {
      sortParams.sort_by = "createdAt";
      sortParams.sort_order = "asc";
    }

    onFilter?.(sortParams);
  };

  return (
    <div className="filterouter align-items-center">
      <div className="breadcrumbinner">
        <div className="w-100">
          <ol className="breadcrumb">
            <li><Link to="/">Home</Link></li>
            <li className="active">Homestays in {locationName}</li>
          </ol>
          {totalProperties > 0 ? (
            <p>{totalProperties} properties available</p>
          ) : (
            <p className="no-results">
              No homestays found in <strong>{locationName}</strong>.
            </p>
          )}
        </div>
        <button
          type="button"
          className="theme-btn filterbtn"
          onClick={onToggleSidebar}
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M3 7C3 6.44772 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H4C3.44772 8 3 7.55228 3 7ZM6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12ZM9 17C9 16.4477 9.44772 16 10 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H10C9.44772 18 9 17.5523 9 17Z" fill="currentColor" />
          </svg>
        </button>
      </div>

      <form className="filterbx" onSubmit={handleSearch}>
        <div className="formgroup">
          <input
            type="text"
            className="form-control"
            placeholder="Enter Home Stay name"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
          <button type="submit" className="searchbtn">
            <i className="icon icon-search"></i>
          </button>
        </div>

        <div className="formgroup">
          <select className="form-select" value={sortBy} onChange={handleSortChange}>
            <option value="" hidden>Sort By:</option>
            <option value="price_low_high">Price: Low to High</option>
            <option value="price_high_low">Price: High to Low</option>
            <option value="newest">Newest</option>
            <option value="oldest">Oldest</option>
          </select>
        </div>
      </form>
    </div>
  );
};

export default BreadcrumbFilterHeader;
